export default __webpack_public_path__ + "static/media/imam.9422a954.png";